import InboxLayout from "../components/inbox/InboxLayout.vue";
import ConversationView from "../components/inbox/ConversationView.vue";
import MessageListView from "../components/inbox/MessageListView.vue";
const routes = {
    path: '/inbox', component: InboxLayout,
    children: [{
            path: ':message_box_id',
            component: MessageListView,
            children: [{
                    path: ':filter',
                    component: MessageListView,
                }]
        }, {
            path: ':message_box_id/conversations/:conversation_id',
            component: ConversationView,
            children: [{
                    path: ':message_id',
                    component: ConversationView,
                }]
        }],
    beforeEnter: (to, from, next) => {
        if (!window.marque.ui.authorisations['access.inbox']) {
            next(false);
            window.location.pathname = '/dashboard';
        }
        else {
            next();
        }
    }
};
export default routes;
